var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconKey = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 10,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#98918A",
  fillRule: "evenodd",
  d: "M4.303.977A3.337 3.337 0 1 1 5.47 6.454l-.99.99a.37.37 0 0 1-.263.109h-.328v.328a.37.37 0 0 1-.109.263l-.35.35a.37.37 0 0 1-.262.108H2.84v.328a.37.37 0 0 1-.109.262l-.699.7A.37.37 0 0 1 1.77 10H.371A.37.37 0 0 1 0 9.63v-1.4a.37.37 0 0 1 .109-.261L3.546 4.53A3.34 3.34 0 0 1 4.303.977M6.75 3.25a.865.865 0 1 1 1.224-1.224A.865.865 0 0 1 6.75 3.25",
  clipRule: "evenodd"
})));
export default SvgIconKey;